<template>
  <div>
    <!-- Cards Monthly Bank Draft -->
    <!-- <div>
      TEMP
      cardAmount: {{ cardAmount }} <BR />
    </div> -->
    <div class="mb-4">
      <v-card
        @click="setCardAsSelected"
        class="clickable px-3"
        :class="[
          isSelected ? 'cardSelected' : 'cardNotSelected',
          cardDisabled ? 'disabledCard' : '',
        ]"
      >
        <v-row wrap>
          <v-col cols="12" class="cardTitle">
            <span v-if="cardDisabled">{{ $t('L_current_method') }}</span> {{ cardTitle }}
            <br />
            {{ cardTitleSub }}
          </v-col>
          <v-col xs="8" class="cardAmount">
            {{ getCurrencyAmount }}
          </v-col>
          <v-col xs="4" class="vertCenterCircleHoriRight mt-1 py-0">
            <div v-if="isSelected">
              <v-icon color="green" :icon="mdiCheckCircle" />
            </div>
          </v-col>
        </v-row>
      </v-card>
      <div class="cardFooter" v-if="showFooterNote">
        <span>{{ $t('L_this_amount_pays_your_premium_through') }}</span>
        <span>{{ footerPayDate }}</span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';

import { currency } from '@/shared/util/formatters';
import { mdiCheckCircle } from '@mdi/js';

const componentOptions: ComponentOptions = {
  name: 'SelectionBox',
  data: () => ({
    // selectedAmount: -1,
    mdiCheckCircle,
  }),
  props: {
    cardDisabled: {
      type: Boolean,
      default: false,
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
    cardTitle: {
      type: String,
      default: '',
    },
    cardTitleSub: {
      type: String,
      default: '',
    },
    cardAmount: {
      type: String,
      default: '',
    },
    showFooterNote: {
      type: Boolean,
      default: false,
    },
    footerPayDate: {
      type: String,
      default: '',
    },
  },
  computed: {
    getCurrencyAmount() {
      return currency(this.cardAmount, 2);
    },
    // selectedAmount() {
    //   if (this.isSelected) {
    //     return 0;
    //   } else {
    //     return -1;
    //   }
    // },
  },
  methods: {
    setCardAsSelected() {
      if (!this.cardDisabled) {
        this.$emit('selected');
      }
    },
  },
};

export default defineComponent(componentOptions);
</script>

<style lang="scss" scoped>
.cardNotSelected {
  max-width: 285px;
  border: 2px solid #cccccc;
  background-color: #ffffff;
  height: 115px;
}

.cardSelected {
  max-width: 285px;
  border: 2px solid #6cd07b;
  background-color: #d8f8dd;
  height: 115px;
}
.disabledCard {
  max-width: 285px;
  border: 2px solid #cccccc;
  background-color: #e3e3e3;
  height: 115px;
}
.cardTitle {
  padding-top: 16px;
  padding-left: 8px;
  font-size: 12px;
  color: #333333;
}
.cardAmount {
  padding-top: 0px;
  padding-left: 8px;
  font-size: 24px;
  font-weight: bold;
  color: #333333;
}

.cardFooter {
  padding-top: 8px;
  font-size: 12px;
  color: #333333;
}
.vertCenterCircleHoriRight {
  margin: auto;
  text-align: right;
  padding-right: 10px;
}
.clickable {
  cursor: pointer;
}
</style>
